module.exports = __webpack_public_path__ + "img/geoLocation.123b93cb.jpg";